// Single unified NpciCall utility — works for all card networks.
// Requires a hidden form with id="paymentPostForm" to exist in the page.
export function NpciCall(resp: any) {
  (document.getElementById("cres") as HTMLInputElement).value = resp.cres;
  (document.getElementById("threeDSSessionData") as HTMLInputElement).value =
    resp.threeDSSessionData;
  (document.getElementById("paymentPostForm") as HTMLFormElement).action =
    resp.notificationURL;
  (document.getElementById("paymentPostForm") as HTMLFormElement).submit();
}
